module.exports = __webpack_public_path__ + "static/img/10.1.5218c6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/10.1.png
// module id = 0cnU
// module chunks = 0